import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NbAuthService } from '@nebular/auth';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class MultivaloresService extends ApiService {
  static getMultivalores(arg0: number): Observable<Multivalores[] | null> {
    throw new Error('Method not implemented.');
  }
  constructor(http: HttpClient, authService: NbAuthService) {
    super(http, authService);
  }
  getMultivalores(iIDSubtabla: number): Observable<Multivalores[] | null> {
    return this.get<Multivalores[]>('/api/Multivalores/GetSubtabla', { iIDSubtabla: iIDSubtabla.toString() }).pipe(shareReplay());
  }

  AddValoresMultivalores(valores: ValoresMultivalores): Observable<number | null> {
    return this.post<number>('/api/Multivalores/AddValoresMultivalores', valores);
  }

}

export interface Multivalores {
  tIDValor: string;
  tDescripcionValor: string;
  tComentario: string;
  dValor: number;
  dtValor: Date;
  bValor: boolean;
  tValor: string;
}

export interface ValoresMultivalores {
  tSubTabla: string;
  Valores: Valores[];

}

export interface Valores {

  tIDValor: string;
  iOrden: number;
  tDescripcionValor: string;
  iTipoParametro?: number;
  dTipoParametro?: string;
  Valor: any;

}